"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalsSink = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const button_1 = require("client/components/ui/button");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./modals.less");
let ModalsSink = class ModalsSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.modal = false;
    }
    render() {
        return (React.createElement("div", { className: "modals" },
            React.createElement("div", { className: "buttons" },
                React.createElement("h2", null, "Confirmation"),
                React.createElement(button_1.UiButton, { onClick: () => (this.modal = true), primary: true }, "Show Modal")),
            this.modal && (React.createElement(confirmation_modal_1.ConfirmationModal, { title: "Unlock order #51023", message: "Unlocking the order is the only way to change which medications have been dispensed and update print labels. You will not be able to print labels while the order is unlocked. ", confirmText: "Unlock", cancelText: "Cancel", onCancel: () => {
                    this.modal = false;
                }, onConfirm: () => {
                    alert("confirmed");
                    this.modal = false;
                } }))));
    }
};
__decorate([
    mobx_1.observable
], ModalsSink.prototype, "modal", void 0);
ModalsSink = __decorate([
    mobx_react_1.observer
], ModalsSink);
exports.ModalsSink = ModalsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/modals/modals.tsx
// module id = 3656
// module chunks = 0